<template>
  <div
    class="question-wrapper view"
    :style="{backgroundImage: `url(${bgImage})`}"
    v-if="loaded"
  >
    <transition-group
      name="slide" tag="div" class="full-area row-area"
    >
      <Screen
        :key="'cid + screen.sys.id'"
        :data="screen"
        v-if="parseInt(cqid, 10) === 0 && loaded"
        v-on:next="pushRoute(1)"
      ></Screen>
      <QRReader2
        :data="qrReader"
        :key="cid + qrReader.sys.id"
        :id="qrReader.sys.id"
        v-if="parseInt(cqid, 10) === 1 && loaded"
        v-on:next="identifyUser($event)"
        v-on:login="pushRoute(2)"
        v-on:register="pushRoute(3)"
      ></QRReader2>
      <Demographic
        :key="'login'"
        :data="login"
        v-if="parseInt(cqid, 10) === 2 && loaded"
        v-on:next="identifyUser($event)"
      ></Demographic>
      <Demographic
        :key="'signup'"
        :data="signup"
        v-if="parseInt(cqid, 10) === 3 && loaded"
        v-on:next="registerNewUser($event)"
      ></Demographic>
    </transition-group>
  </div>
</template>

<script>
import Fingerprint2 from 'fingerprintjs2'
import Vue from 'vue'

export default {
  props: [ 'bgImage' ],

  name: 'Collect',

  components: {
    Screen: () => import('Components/questions/Screen'),
    Demographic: () => import('Components/questions/Demographic'),
    QRReader2: () => import('Components/questions/QRReader2')
  },

  data () {
    return {
      status: 0,
      loaded: false,
      leal: '',
      screen: {},
      qrReader: {},
      login: {},
      signup: {}
    }
  },

  computed: {
    cid () {
      return this.$route.params.cid
    },
    cqid () {
      return this.$route.params.cqid
    },
    data () {
      return this.$store.state.survey.collectPersonalData
    }
  },

  async mounted () {
    setTimeout(async () => {
      var collect = await this.$store.dispatch('LOAD_ENTRY', { entryId: this.$route.params.cid })
      this.$store.commit('SET_COLLECT', { collect: collect })
      this.loadScreen()
      this.loadQR()
      this.loadLogin()
      this.loadSignup()
    }, 100)
  },

  methods: {
    pushRoute (cqid) {
      this.$router.push(`/collect/${this.cid}/${cqid}`)
    },
    identifyUser (event) {
      this.$store.dispatch('IDENTIFY_EXISTING_USER', {
        phoneId: event.data.phoneId,
        survey: this.$store.state.survey,
        fingerprint: this.$store.state.fingerprint
      }).then(data => {
        this.$store.commit('DELETE_RECENT_SURVEY_SET')
        console.log('SUCCESS!!!', data)
      }).catch(err => {
        console.log('err: ', err)
      })
    },
    registerNewUser (event) {
      this.$store.dispatch('REGISTER_USER', {
        data: event.data,
        survey: this.$store.state.survey,
        fingerprint: this.$store.state.fingerprint
      }).then(data => {
        this.$store.commit('DELETE_RECENT_SURVEY_SET')
        console.log('SUCCESS!!!', data)
      }).catch(err => {
        console.log('err: ', err)
      })
    },
    next () {
      this.status++
    },
    async loadScreen () {
      this.loaded = false
      var data = this.$store.state.survey.collectPersonalData
      if (this.data && this.data.welcomeScreen) {
        // load the screen and show it
        Vue.set(this.screen, 'sys', this.data.welcomeScreen.sys)
        this.screen.fields = await this.$store.dispatch('LOAD_ENTRY', { entryId: this.data.welcomeScreen.sys.id })
        this.status = 1
        this.loaded = true
      }
    },
    async loadQR () {
      this.loaded = false
      var data = this.$store.state.survey.collectPersonalData
      if (this.data && this.data.qrReader) {
        this.qrReader.sys = this.data.qrReader.sys
        this.qrReader.fields = await this.$store.dispatch('LOAD_ENTRY', { entryId: this.data.qrReader.sys.id })
        this.loaded = true
      }
    },
    async loadLogin () {
      this.loaded = false
      var data = this.$store.state.survey.login
      if (this.data && this.data.login) {
        this.login.sys = this.data.login.sys
        this.login.fields = await this.$store.dispatch('LOAD_ENTRY', { entryId: this.data.login.sys.id })
        this.loaded = true
      }
    },
    async loadSignup () {
      this.loaded = false
      var data = this.$store.state.survey.signup
      if (this.data && this.data.signup) {
        this.signup.sys = this.data.signup.sys
        this.signup.fields = await this.$store.dispatch('LOAD_ENTRY', { entryId: this.data.signup.sys.id })
        this.loaded = true
      }
    }
  }
}
</script>

<style scoped lang="scss">

.full-area,
.question-wrapper {
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
}
</style>

<style lang="scss">
.el-drawer__body {
  overflow-y: scroll;
}
</style>
